
export class UsuarioModel {

    nome?: String;
    nomfil?: String;
    departamento?: String;
    cargo?: String;
    email?: String;
    empresa?: String;
    filial?: String

    constructor () {
        
        this.nome = 'Menu';
        this.nomfil = '';
        this.departamento = '';
        this.cargo = '';
        this.email = '';
        this.empresa = '';
        this.filial = '';

    }

}



// WEBPACK FOOTER //
// ./src/models/usuario-model.ts